<template>
  <div>
    <v-container grid-list-xs  pt-0>
      <v-layout row wrap>
        <v-flex lg12>
          <v-flex lg8 offset-lg2 v-if="externalFvc">
            <LinkFormCard :image="externalFvc"></LinkFormCard>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import LinkFormCard from "./LinkFormCard";
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";


export default {
  computed: {
    ...mapGetters(["externalFvc", "loadingExternal","agency"])
  },
  mounted() {
    this.$store.dispatch("external");
    console.log(this.agency);
  },
  components: {
    LinkFormCard
  },
  methods:{},
  watch: {
    loadingExternal(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando configuración");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val){
      this.$store.dispatch("external");
    }
  },
  data() {
    return {};
  }
};
</script>